import Acquiring from "../JS_moments/Acquiring";

const ShopBlock = ({ shopData }) => {
    const userEmail = localStorage.getItem("email") || "";

    return (
        <div className="sale-block-user-console profile-block-main">
            <div className="title-profile-block-main">
                <div className="group-elements-title-profile-main">
                    <div className="wrapper-title-main">
                        <h1>Оформить подписку</h1>
                    </div>
                </div>
                <hr />
            </div>
            <div className="content-block-sale-block content-profile-block-main">
                <div className="content-section-sale-block">
                    <table className="cost-description-sale-block">
                        <tbody>
                        {shopData.success ? (
                            <>
                                {shopData.firstPayment !== shopData.monthlyPayment && (
                                    <tr>
                                        <td><span>Первый платёж</span></td>
                                        <td className="cost"><span>{shopData.firstPayment} ₽</span></td>
                                    </tr>
                                )}
                                <tr>
                                    <td><span>Последующие платежи</span></td>
                                    <td className="cost">
                                        <span>
                                          {shopData.monthlyPayment} ₽
                                            {shopData.monthlyPayment < 600
                                                ? ' /мес'
                                                : shopData.monthlyPayment === 600
                                                    ? ' /пол года'
                                                    : ' /год'}
                                        </span>
                                    </td>
                                </tr>

                            </>
                        ) : (
                            <tr>
                                <td><span>Загрузка цен..</span></td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
                <div className="content-section-sale-block">
                    <div className="cost-benefits-sale-block">
                        <h1>Преимущества подписки:</h1>
                        <span>—&nbsp;&nbsp;&nbsp;Безлимит трафика</span>
                        <span>—&nbsp;&nbsp;&nbsp;Без ограничений скорости</span>
                        <span>—&nbsp;&nbsp;&nbsp;Доступ к иностранным сервисам</span>
                        <span>—&nbsp;&nbsp;&nbsp;Отсутствие рекламы</span>
                    </div>
                </div>
                <Acquiring
                    firstPrice={shopData.firstPayment}
                    subPrice={shopData.monthlyPayment}
                    email={userEmail}
                />
            </div>
        </div>
    );
};

export default ShopBlock;
